<template>
  <div>
    <top-img-temp :imgUrl="topImg" :cName="cName" :e-name="eName"></top-img-temp>

    <div class="section2">
      <div v-for="(item,index) in newsList"
           class="newsBox"
           @click="gotoDetail(item.id,item)"
           :key="index">
        <div class="newsBox_left">
          <img :src="item.cover" alt="">
        </div>
        <div class="newsBox_right">
          <div class="newsBox_right_inner">
            <p class="p1">{{isChinese? item.title:item.titleEn}}</p>
            <div class="heng"></div>
            <p class="p2">{{isChinese? item.simple:item.simpleEn}}</p>
            <p class="p3">{{item.activityTime}}</p>
          </div>
        </div>
      </div>
      <div class="fenye">
        <el-pagination @size-change="sizeChangeHandle"
                       @current-change="currentChangeHandle"
                       :current-page="pageIndex"
                       :page-size="pageSize"
                       :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>


      </div>
    </div>

  </div>
</template>

<script>
  import topImgTemp from '../baseTemp/topImgTemp'
  export default {
    name: "news",
    data() {
      return {
        isChinese: undefined,
        topImg: require('../../../static/images/base/XWZX-35.jpg'),
        cName: '新闻中心',
        eName: 'News Center',
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        newsList: []
      }
    },
    components: {topImgTemp},
    computed: {
      setCAE() {
        return this.$store.state.cAeSatus;
      }
    },
    watch: {
      //监听路由变化
      setCAE(newVal) {
        this.isChinese = newVal === 1 ? true : false;
      }
    },
    created() {
      this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;

      this.getNewsList()
    },
    methods:{
      gotoDetail(id,item) {
        let routeData = this.$router.resolve({
          path: "/News/NewsDetail/id=" + id ,
          query: {'title': item.title}
        });
        window.open(routeData.href, '_blank');
      },
      getNewsList () {
        let _this = this
        _this.$http
          .get("/jishi/api/activity/list", {
            params: {
              page: _this.pageIndex,
              limit: _this.pageSize
            }
          })
          .then(
            function (response) {
              if (response && response.data.code === 0) {
                let resData = response.data.page
                _this.pageSize = resData.totalCount
                _this.totalPage = resData.totalCount
                _this.newsList = resData.list
              }
            }.bind(this)
          )
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getNewsList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getNewsList()
      },
    }
  }
</script>

<style scoped lang="stylus">
  img {
    width: 100%;
    height: 100%;
  }
  .newsBox {
    width: 60%;
    margin: 0 auto;
    display: flex;
    margin-top: 4vw;
    border-bottom: 1px solid #cccccc ;
    cursor: pointer;
    just-content:space-between
  }
  .newsBox:hover {
    border-bottom: 1px solid white;
    box-shadow: 3px 3px 8px #dddddd;
  }
  .newsBox_left {
    width: 20vw;
    min-width: 240px;
    object-fit: cover;
    display :flex;
    align-items :center;
  }
  @media screen and (max-width:800px){
    .newsBox {
      display: block;
      width 95%
    }
    .newsBox_left {
      width 90vw
      margin 0 auto
    }
    .newsBox_right_inner {
     width: 100% !important;
  }
  .newsBox_right_inner>p{
    padding-left: 3vw !important;
    padding-right: 3vw !important;
  }
    .newsBox_right_inner>p2{
    max-lines: 2 !important;
  }
  .heng{
    margin-left: 3vw !important;
    width :10vw !important;
  }
  }
  .newsBox_left img {
    width: 100%;
  }
  .newsBox_right {
    flex: 1;
  }
  .newsBox_right_inner {
    width: 90%;
    height: 100%;
  }
  .newsBox_right_inner>p{
    padding-left: 7vw;
    color: #666666;
  }
  .newsBox_right_inner .p1 {
    font-size: 2rem;
  }
  .newsBox_right_inner .p2 {
    font-size: 1.5rem;
    line-height: 25px;
  }
  .newsBox_right_inner .p3{
    font-size: 1.5rem;
    /*padding-top: 4px;*/
  }
  .heng {
    width: 5vw;
    height: 2px ;
    margin-left: 7vw;
    background-color: #F5D382;
  }
  .fenye {
    margin: 20px 0 ;
    height: 40px;
    display: flex;
    justify-content: center;
  }

  .fenye >>> .el-icon-arrow-left:before, .fenye >>> .el-icon-arrow-right:before{
    display: block;
  }
  .fenye >>> .el-icon-arrow-right:before{
    display: block
  }
  .fenye >>> .el-pagination button {
    width: auto;
  }
  .fenye >>> .el-pager  {
    width: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/News2/index.vue